// src/lib/firestore.js
import { firestoreDb } from './firebase';
import { browser } from '$app/environment';
import { logError } from './helpers/errors';    

export async function db() {
    if (browser) {
        try {
            return await firestoreDb();
        } catch (error) {
            logError(error, "Error initializing Firestore in browser environment");
            return null;
        }
    } else {
        return null;
    }
}